import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-refer-earn-dash',
  templateUrl: './refer-earn-dash.component.html',
  styleUrls: ['./refer-earn-dash.component.scss'],
})
export class ReferEarnDashComponent implements OnInit  {

  constructor( public router:Router) { }

  ngOnInit() {}
  referProvider(){
    this.router.navigate(['/referprovider']);
  }
  referFrd(){
    this.router.navigate(['/addreferral']);
  }
  referOrg(){
    this.router.navigate(['/addOrgreferral']);
  }
}
